import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import TeamMemberTable from "./TeamMemberTable";

function TeamMembers() {
  const location = useLocation();

  const [teamId, ] = useState(location.state.teamID);
  const [teamMembers, setteamMembers] = useState(null);


  useEffect(() => {
    if (teamId) {
      axios.post("/returnTeamMembers", { teamId: teamId }).then((data) => {
        // console.log("Team members:", data.data);
        setteamMembers(data.data);
      });
    }

    // console.log("Team ID:", location.state.teamID);
  }, [teamId]);

  return (
    <Container>
      {(teamMembers && teamMembers?.length !== 0) && 
        <TeamMemberTable data={teamMembers} />
      }
    </Container>
  );
}

export default TeamMembers;

const Container = styled.div`
  padding: 25px;
`;

